import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import {
  brandOverride,
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { transformHourToDayHour } from '../../../../../../helper/horloge';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00043-pac-statut',
  templateUrl: './p00043-pac-statut.component.html',
  styleUrls: ['./p00043-pac-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    TranslatePipe,
    CollapseComponent,
  ],
})
export class P00043PacStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  editValue(index: any, key: string, value: any): void {
    this.actionStack!.editValue(index, key, value);
  }

  commit(): void {
    this.actionStack!.commit();
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  get hasAlarm(): boolean {
    return this.getValue('paSAlarme') === 1;
  }

  get regulationHasAlarm(): boolean {
    return (
      this.getValue('paSArretCommandDebit') === 1 &&
      ((this.getValue('paCModeFonctionnement') === 1 &&
        this.getValue('paSCommandeHorloge') === 1) ||
        this.getValue('paCModeFonctionnement') === 3)
    );
  }

  get debitDetectionReference(): string {
    if (this.getValue('paSDetectionDebitReference') === 0) {
      return this.translateService.instant('P00043.status.indisponible');
    } else if (this.getValue('paSDetectionDebitReference') === 1) {
      return this.translateService.instant('P00043.status.absent');
    } else {
      return this.translateService.instant('P00043.status.present');
    }
  }

  protected readonly transformHourToDayHour = transformHourToDayHour;
  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly brandOverride = brandOverride;
}
